import { TenantState } from './types';
import {
  MAX_CHARS_FOR_TENANT_NAME,
  MIN_CHARS_FOR_TENANT_NAME,
  NAME_PATTERN,
} from 'src/constants';
import { ManagementPolicy } from 'src/types/rest/tenant';

export const isTenantValid = (tenants: TenantState) => {
  if (tenants.error) return false;

  const { managementPolicy, name } = tenants;
  const { zeissManaged } = ManagementPolicy;

  if (name.length < MIN_CHARS_FOR_TENANT_NAME) return false;

  if (name.length > MAX_CHARS_FOR_TENANT_NAME) return false;

  if (!name.match(NAME_PATTERN)) return false;

  if (managementPolicy !== zeissManaged) return false;

  return true;
};
